import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-user',
  templateUrl: './modal-view-user.component.html',
  styleUrls: ['./modal-view-user.component.scss']
})
export class ModalViewUserComponent implements OnInit {

  comertialAgreements: any = [];
  debtStatuses: any = this.uService.debtStatuses;
  roles: any = [];
  genders: any = this.uService.genders;
  userStatuses: any = this.uService.userStatuses;

  newUserForm: FormGroup = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    username: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    cellphone: new FormControl('', Validators.required),
    role: new FormControl([], Validators.required),
    // gender: new FormControl('', Validators.required),
    // ci: new FormControl('', Validators.required),
    // status: new FormControl('', Validators.required),
  });

  getRoles(){
    this.mService.get_request('rol/list')
    .subscribe((resp: any)=>{
      var rolesResp: any = [];
      if(resp.status){
        Object.keys(resp.items).forEach(key => {
          var roleNameModified: string = '';

          // switch (resp.items[key].role_name) {
          //   case 'superadmin':
          //     roleNameModified = 'Super administrador'
          //   break;
          //   case 'admin':
          //     roleNameModified = 'Administrador'
          //   break;
          //   case 'accounting':
          //     roleNameModified = 'Contabilidad'
          //   break;
          //   case 'trading':
          //     roleNameModified = 'Comercio'
          //   break;
          // }
          rolesResp.push(
            {
              ...resp.items[key],
              // roleNameModified
            }
          )
        });
        this.roles = rolesResp;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.getRoles();

    this.newUserForm.get('first_name').setValue(this.data.first_name);
    this.newUserForm.get('last_name').setValue(this.data.last_name);
    this.newUserForm.get('username').setValue(this.data.username);
    this.newUserForm.get('email').setValue(this.data.email);
    this.newUserForm.get('cellphone').setValue(this.data.cellphone);
    // this.newUserForm.get('gender').setValue(this.data.gender);
    // this.newUserForm.get('ci').setValue(this.data.ci);
    // this.newUserForm.get('status').setValue(this.data.status);
    if(this.data.roles.length > 0){
      var roles: any = [];
      this.data.roles.forEach(role => {
        roles.push(role.id);
      });
      this.newUserForm.get('role').setValue(roles);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

